import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { selectAddress } from "../store";
import { Address } from "../../Address";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _ConvergentAddress = function _ConvergentAddress(_ref) {
  var address = _ref.address;
  return /*#__PURE__*/React.createElement(Address, {
    address: address,
    className: cn('address'),
    "data-t-id": "ConvergentTariff-ConvegentAddress"
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    address: selectAddress(state)
  };
};
export var ConvergentAddress = connect(mapStateToProps)(_ConvergentAddress);